import {
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    HostBinding,
    Input,
    OnChanges,
    Renderer2,
    SimpleChanges,
} from "@angular/core";
import { SpsIcon, TagKind } from "@spscommerce/ds-shared";

@Component({
    selector: "sps-tag",
    template: `
        <i *ngIf="icon" class="sps-icon sps-icon-{{icon}}"></i><ng-content></ng-content>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpsTagComponent implements OnChanges {
    static readonly displayName = "sps-tag";
    static readonly props = {
        kind: "TagKind",
        icon: "SpsIcon",
    };

    @Input() kind: TagKind = TagKind.DEFAULT;
    @Input() icon: SpsIcon;

    @HostBinding("class.sps-badge") readonly _spsBadgeClass = true;

    constructor(private _elementRef: ElementRef, private _renderer: Renderer2) {}

    ngOnChanges(changes: SimpleChanges) {
        if (changes.kind) {
            this._renderer.removeClass(
                this._elementRef.nativeElement,
                `sps-badge--${changes.kind.previousValue}`
            );
            this._renderer.addClass(
                this._elementRef.nativeElement,
                `sps-badge--${changes.kind.currentValue}`
            );
        }
    }
}
